module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-02.d8c419d4.jpg";